<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>分享与推送</el-breadcrumb-item>
          <el-breadcrumb-item>推送给我</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>推送给我</h4>
        <!-- <p>+新增用户</p> -->
      </div>

      <div class="tablebg"
           v-loading="isRefresh">
        <div style="width:100%;margin:0 auto;">
          <mypushtable :tableData="tableData"
                       :isToMe='isToMe'
                       @seePic="seePic"></mypushtable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mypushtable } from "@/components/index";
import { listPicturePackage, getPicturePackage } from "@/api/picturePackage";
import { getDate, formatConversion } from "@/plugins/getdate";
import { getPushChannel } from "@/api/pushChannel";
import { getUser } from "@/api/user";
export default {
  components: {
    mypushtable: mypushtable
  },

  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      timeInt: "",
      isRefresh: false,

      isToMe:false
    };
  },
  methods: {
    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        packageType: "push",
        targetUid:localStorage.getItem('createUid')
      };
      // console.log(data)
      this.listPicturePackageAsync(data);
    },

    //刷新表格
    refresh () {
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },

    seePic (data) {
      // console.log(data.row)
      this.$router.push({
        path: "/shareAndPush/show",
        query: {
          data: JSON.stringify(data.row)
        }
      });
    },

    //获取下载列表

    async listPicturePackageAsync (val) {
      this.isRefresh = true;
      let { status, data, message, pagination, errors } = await listPicturePackage(val);
      if (status) {
        this.total = pagination.total;

        for (let i = 0; i < data.length; i++) {
          let shareInfo = await getPicturePackage(data[i].id);
          shareInfo.data.pushConfig = JSON.parse(shareInfo.data.pushConfig);
          if (
            shareInfo.data.pushConfig.pushChannelId &&
            shareInfo.data.pushConfig.pushChannelId !== 0
          ) {
            let shareChannel = await getPushChannel(
              shareInfo.data.pushConfig.pushChannelId
            );
            if (shareChannel.status) {
              data[i].channel = shareChannel.data.name;
            } else {
              data[i].channel = "暂无";
            }
          } else if (shareInfo.data.pushConfig.pushChannelId === 0) {
            data[i].channel = "图片邀约";
          } else {
            data[i].channel = "暂无";
          }

          let laiInfo = await getUser(data[i].createUid)
          data[i].toPushName = laiInfo.data.name

          // data[i].channel = shareChannel.data.name

          data[i].createAtMY = formatConversion(data[i].createAt.toString());
        }

        this.tableData = data;
        this.isRefresh = false;
      } else {
        this.isRefresh = false;
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    clearTimeout(this.timeInt);
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./pushtome.scss";

h4 {
  font-size: 18px;
}
</style>
